var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", {
    style: {
      width: _vm.percent + "%",
      height: _vm.height,
      "background-color": _vm.canSuccess ? _vm.color : _vm.failedColor,
      opacity: _vm.show ? 1 : 0,
    },
    attrs: { id: "progress-bar" },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }